var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJetidIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    fill: "none",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 84.7296,
    x2: 4.59178,
    y1: 83.1091,
    y2: 6.50678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01694,
    stopColor: "#21D789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.30776,
    stopColor: "#009AE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.70553,
    stopColor: "#6B57FF"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M96 0H0V95.9998H96V0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47.9999 78H12V84H47.9999V78Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.2573 11.7471H20.0655V47.6996H12.2573V11.7471Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.6699 11.7471H41.5121C52.666 11.7471 60.3734 19.5025 60.3734 29.6205V29.723C60.3734 39.8416 52.666 47.6996 41.5121 47.6996H27.6699V11.7471ZM35.4781 18.8861V40.5605H41.5121C47.9 40.5605 52.2101 36.1947 52.2101 29.8261V29.723C52.2101 23.3545 47.9 18.8861 41.5121 18.8861H35.4781V18.8861Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJetidIcon);
export default __webpack_public_path__ + "static/media/jetid-icon.bdeeb8deb72f52a04875b1b7b469be8e.svg";
export { ForwardRef as ReactComponent };